import * as React from "react";
import { Box } from "@twilio/flex-ui/node_modules/@twilio-paste/box";
import { Text } from "@twilio/flex-ui/node_modules/@twilio-paste/core/node_modules/@twilio-paste/text";
import { Flex } from "@twilio/flex-ui/node_modules/@twilio-paste/core/flex"

export class WorkersDataTableSelectionColumnHeader extends React.Component {

    toggleAll = (e) => {
        var checkboxes = document.getElementsByName('chkStatus');    
        for(const checkbox of checkboxes)
        {
            if(checkbox?.checked != null)
            {
                checkbox.checked = e.target.checked;
            }
        }
    }
 
    render() {
        return (<Box as="p">
                    <Flex>
                        <input
                            id="chkAll" 
                            type="checkbox"
                            onChange={this.toggleAll} /> 
                        <Text>Select All</Text>
                    </Flex>
                </Box>)
    }
}
